import React from 'react';
import {
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
  all
} from 'redux-saga/effects';
import * as ga from '../redux/actions/app';
import { notification } from 'antd';
import { push } from 'react-router-redux';
import { ROUTE_AMLS_SMART_SCREENING } from '../pages/constants/globalConstants';
import { UNIFIED_ALERT_METRICS } from '../pages/constants/commonConstants';

import {
  //Alerts
  GET_AMLS_COMMON_UNIFIED_ALERTS,
  getAMLSCommonUnifiedAlertsSuccess,
  getAMLSCommonUnifiedAlertsFail,
  GET_AMLS_COMMON_KYC_ALERTS,
  GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD,
  getCommonKYCcustomersSuccess,
  getCommonKYCcustomersFail,
  getCommonKYCcustomersDownloadSuccess,
  getCommonKYCcustomersDownloadFail,
  GET_AMLS_COMMON_ALERT_DETAILS,
  getAMLSCommonAlertDetailsSuccess,
  getAMLSCommonAlertDetailsFail,
  GET_AMLS_COMMON_ALERT_PARTY_IDENTITY,
  getAMLSCommonAlertPartyIdentitySuccess,
  getAMLSCommonAlertPartyIdentityFail,
  GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS,
  getAMLSCommonAlertAssocCustomersSuccess,
  getAMLSCommonAlertAssocCustomersFail,
  GET_AMLS_COMMON_TICKETS,
  getAMLSCommonTicketsSuccess,
  getAMLSCommonTicketsFail,
  PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
  putAMLSCommonApproveAndRejectTicketSuccess,
  putAMLSCommonApproveAndRejectTicketFail,
  PUT_AMLS_COMMON_ALERT_PARTY_UPDATE,
  putAMLSCommonAlertPartyUpdateSuccess,
  putAMLSCommonAlertPartyUpdateFail,
  GET_AMLS_COMMON_SANDBOX_UI,
  getAMLSCommonSandboxUISuccess,
  getAMLSCommonSandboxUIFail,
  resetAMLSCommonApproveAndRejectTicket,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES,
  getAMLSCommonDynamicPropertiesCategoriesFail,
  getAMLSCommonDynamicPropertiesCategoriesSuccess,
  GET_AMLS_COMMON_DYNAMIC_PROPERTIES,
  getAMLSCommonDynamicPropertiesSuccess,
  getAMLSCommonDynamicPropertiesFail,
  PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE,
  putAMLSCommonDynamicPropertiesUpdateSuccess,
  putAMLSCommonDynamicPropertiesUpdateFail,
  GET_AMLS_COMMON_PIPELINES,
  getAMLSCommonPipelinesSuccess,
  getAMLSCommonPipelinesFail,
  POST_AMLS_COMMON_PIPELINES_RUN,
  postAMLSCommonPipelinesRunSuccess,
  postAMLSCommonPipelinesRunFail,
  POST_AMLS_COMMON_PIPELINES_SCHEDULE,
  postAMLSCommonPipelinesScheduleSuccess,
  postAMLSCommonPipelinesScheduleFail,
  POST_AMLS_COMMON_PIPELINES_UNSCHEDULE,
  postAMLSCommonPipelinesUnScheduleSuccess,
  postAMLSCommonPipelinesUnScheduleFail,
  GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO,
  getAMLSCommonPipelinesScheduleInfoSuccess,
  getAMLSCommonPipelinesScheduleInfoFail,
  getAMLSCommonPipelinesHistorySuccess,
  getAMLSCommonPipelinesHistoryFail,
  GET_AMLS_COMMON_PIPELINES_HISTORY,
  getAMLSCommonPipelines,
  POST_AMLS_COMMON_PIPELINE_STOP,
  postAMLSCommonPipelineStopSuccess,
  postAMLSCommonPipelineStopFail,
  fetchTypologiesActionsFail,
  fetchTypologiesActionsSuccess,
  FETCH_TRM_ACTIONS_OF_TYPOLOGIES,
  GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION,
  getAMLSCommonUnifiedAlertsPreventionSuccess,
  getAMLSCommonUnifiedAlertsPreventionFail,
  GET_AMLS_COMMON_NOTIFICATIONS,
  getAMLSCommonNotificationsSuccess,
  getAMLSCommonNotificationsFail,
  FETCH_AMLS_ALERT_LEVEL,
  fetchAMLSAlertLevelSuccess,
  fetchAMLSAlertLevelFail,
  GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS,
  getAMLSCommonUnifiedAlertCountsSuccess,
  getAMLSCommonUnifiedAlertCountsFail,
  GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_BY_METRIC_NAME,
  getAMLSCommonUnifiedAlertCountsByMetricsNameSuccess,
  getAMLSCommonUnifiedAlertCountsByMetricsNameFail,
  GET_AMLS_COMMON_TICKET_DETAILS,
  getAMLSCommonTicketDetailsSuccess,
  getAMLSCommonTicketDetailsFail
} from '../redux/actions/common';
import { postDeployToProduction } from '../redux/actions/ns/runInstance';

import * as api from '../services/common';
import { en } from '../pages/common/Pipelines/constants';
import { isArray } from 'lodash';

const networkLayerObject = new api.NetworkLayer();

function* amlsCommonUnifiedAlerts(payload) {
  const { COUNT_FOR_PAGINATION } = UNIFIED_ALERT_METRICS;
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const [response, count] = yield all([
      call(networkLayerObject.amlsCommonUnifiedAlertsAPI, payload),
      call(networkLayerObject.amlsCommonUnifiedAlertCountsByMetricsNameAPI, {
        metricName: COUNT_FOR_PAGINATION,
        data: payload
      })
    ]);

    yield put(
      getAMLSCommonUnifiedAlertsSuccess({
        payload: response?.payload,
        total: count?.count
      })
    );
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonUnifiedAlertsFail({ error }));
  }
}

export function* watchAMLSCommonUnifiedAlerts() {
  yield takeEvery(GET_AMLS_COMMON_UNIFIED_ALERTS, function* ({ payload }) {
    yield fork(amlsCommonUnifiedAlerts, payload);
  });
}

function* amlsCommonUnifiedAlertCounts(payload) {
  try {
    const response = yield call(
      networkLayerObject.amlsCommonUnifiedAlertCountsAPI,
      payload
    );

    yield put(getAMLSCommonUnifiedAlertCountsSuccess(response));
  } catch (error) {
    yield put(getAMLSCommonUnifiedAlertCountsFail({ error }));
  }
}

export function* watchAMLSCommonUnifiedAlertCounts() {
  yield takeEvery(
    GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS,
    function* ({ payload }) {
      yield fork(amlsCommonUnifiedAlertCounts, payload);
    }
  );
}

function* amlsCommonUnifiedAlertCountsByMetricsName(payload) {
  try {
    const response = yield call(
      networkLayerObject.amlsCommonUnifiedAlertCountsByMetricsNameAPI,
      payload
    );

    yield put(getAMLSCommonUnifiedAlertCountsByMetricsNameSuccess(response));
  } catch (error) {
    yield put(getAMLSCommonUnifiedAlertCountsByMetricsNameFail({ error }));
  }
}

export function* watchAMLSCommonUnifiedAlertCountByMetricsName() {
  yield takeEvery(
    GET_AMLS_COMMON_UNIFIED_ALERT_COUNTS_BY_METRIC_NAME,
    function* ({ payload }) {
      yield fork(amlsCommonUnifiedAlertCountsByMetricsName, payload);
    }
  );
}

function* amlsCommonUnifiedAlertsPrevention(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonUnifiedAlertsPreventionAPI,
      payload
    );

    yield put(getAMLSCommonUnifiedAlertsPreventionSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonUnifiedAlertsPreventionFail({ error }));
  }
}

export function* watchAMLSCommonUnifiedAlertsPrevention() {
  yield takeEvery(
    GET_AMLS_COMMON_UNIFIED_ALERTS_PREVENTION,
    function* ({ payload }) {
      yield fork(amlsCommonUnifiedAlertsPrevention, payload);
    }
  );
}

function* amlsCommonKYCAlerts(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonKYCAlertsAPI,
      payload
    );
    yield put(getCommonKYCcustomersSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getCommonKYCcustomersFail({ error }));
  }
}

export function* watchAMLSCommonKYCAlerts() {
  yield takeEvery(GET_AMLS_COMMON_KYC_ALERTS, function* ({ payload }) {
    yield fork(amlsCommonKYCAlerts, payload);
  });
}

function* amlsTypologyActionsDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommontrmTypologiesActionsAPI,
      payload
    );
    yield put(fetchTypologiesActionsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(fetchTypologiesActionsFail({ error }));
  }
}

export function* watchAMLSCommonTypologyActions() {
  yield takeEvery(FETCH_TRM_ACTIONS_OF_TYPOLOGIES, function* () {
    yield fork(amlsTypologyActionsDataWorker);
  });
}

function* amlsCommonKYCAlertsDownload(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonKYCAlertsDownloadAPI,
      payload
    );
    yield put(getCommonKYCcustomersDownloadSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getCommonKYCcustomersDownloadFail({ error }));
  }
}

export function* watchAMLSCommonKYCAlertsDownload() {
  yield takeEvery(GET_AMLS_COMMON_KYC_ALERTS_DOWNLOAD, function* ({ payload }) {
    yield fork(amlsCommonKYCAlertsDownload, payload);
  });
}

function* amlsCommonAlertDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonAlertDetailsAPI,
      payload
    );

    yield put(getAMLSCommonAlertDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonAlertDetailsFail({ error }));
  }
}

export function* watchAMLSCommonAlertDetails() {
  yield takeEvery(GET_AMLS_COMMON_ALERT_DETAILS, function* ({ payload }) {
    yield fork(amlsCommonAlertDetails, payload);
  });
}

function* amlsCommonAlertPartyIdentity(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonAlertPartyIdentityAPI,
      payload
    );

    yield put(getAMLSCommonAlertPartyIdentitySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonAlertPartyIdentityFail({ error }));
  }
}

export function* watchAMLSCommonAlertPartyIdentity() {
  yield takeEvery(
    GET_AMLS_COMMON_ALERT_PARTY_IDENTITY,
    function* ({ payload }) {
      yield fork(amlsCommonAlertPartyIdentity, payload);
    }
  );
}

function* amlsCommonAlertAssocCustomers(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonAlertAssocCustomersAPI,
      payload
    );

    yield put(getAMLSCommonAlertAssocCustomersSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonAlertAssocCustomersFail({ error }));
  }
}

export function* watchAMLSCommonAlertAssocCustomers() {
  yield takeEvery(
    GET_AMLS_COMMON_ALERT_ASSOC_CUSTOMERS,
    function* ({ payload }) {
      yield fork(amlsCommonAlertAssocCustomers, payload);
    }
  );
}

function* amlsCommonGetTickets(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetTicketsAPI,
      payload
    );
    yield put(getAMLSCommonTicketsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonTicketsFail({ error }));
  }
}

export function* watchAMLSCommonGetTickets() {
  yield takeEvery(GET_AMLS_COMMON_TICKETS, function* ({ payload }) {
    yield fork(amlsCommonGetTickets, payload);
  });
}

function* amlsCommonGetTicketDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetTicketDetailsAPI,
      payload
    );
    yield put(getAMLSCommonTicketDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonTicketDetailsFail({ error }));
  }
}

export function* watchAMLSCommonGetTicketDetails() {
  yield takeEvery(GET_AMLS_COMMON_TICKET_DETAILS, function* ({ payload }) {
    yield fork(amlsCommonGetTicketDetails, payload);
  });
}

function* amlsCommonApproveAndRejectTicket(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    let approveNRejectParam = {
      status: payload?.status,
      ticketId: payload?.ticketId,
      reason: payload?.reason
    };

    let deployToProductionParam = {
      championName: payload?.championName,
      runInstanceId: payload?.runInstanceId
    };

    const response = yield call(
      networkLayerObject.amlsCommonApproveAndRejectTicketAPI,
      approveNRejectParam
    );

    if (response.status === 200) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `Successfully ${approveNRejectParam.status}.`
      });
      if (payload.status === 'Approved') {
        yield put(postDeployToProduction(deployToProductionParam));
      }
      yield put(putAMLSCommonApproveAndRejectTicketSuccess(response));
      yield put(ga.fetchSuccess());
      yield put(push(`${ROUTE_AMLS_SMART_SCREENING}/tickets`));
      yield put(resetAMLSCommonApproveAndRejectTicket());
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(ga.fetchFailed({ error: '' }));
    yield put(putAMLSCommonApproveAndRejectTicketFail({ error }));
  }
}

export function* watchAMLSCommonApproveAndRejectTicket() {
  yield takeEvery(
    PUT_AMLS_COMMON_APPROVE_AND_REJECT_TICKET,
    function* ({ payload }) {
      yield fork(amlsCommonApproveAndRejectTicket, payload);
    }
  );
}

function* amlsCommonAlertPartyUpdate(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonAlertPartyUpdateAPI,
      payload
    );

    yield put(putAMLSCommonAlertPartyUpdateSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(putAMLSCommonAlertPartyUpdateFail({ error }));
  }
}

export function* watchAMLSCommonAlertPartyUpdate() {
  yield takeEvery(PUT_AMLS_COMMON_ALERT_PARTY_UPDATE, function* ({ payload }) {
    yield fork(amlsCommonAlertPartyUpdate, payload);
  });
}

function* amlsCommonGetSandboxUI(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonSandboxUI,
      payload
    );
    yield put(getAMLSCommonSandboxUISuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonSandboxUIFail({ error }));
  }
}

export function* watchAMLSCommonGetSandboxUI() {
  yield takeEvery(GET_AMLS_COMMON_SANDBOX_UI, function* ({ payload }) {
    yield fork(amlsCommonGetSandboxUI, payload);
  });
}

function* amlsGetDynamicPropertiesCategories(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetDynamicPropertiesCategoriesAPI,
      payload
    );
    yield put(getAMLSCommonDynamicPropertiesCategoriesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonDynamicPropertiesCategoriesFail({ error }));
  }
}

export function* watchGetDynamicPropertiesCategories() {
  yield takeEvery(
    GET_AMLS_COMMON_DYNAMIC_PROPERTIES_CATEGORIES,
    function* ({ payload }) {
      yield fork(amlsGetDynamicPropertiesCategories, payload);
    }
  );
}

function* amlsGetDynamicProperties(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetDynamicPropertiesAPI,
      payload
    );
    yield put(getAMLSCommonDynamicPropertiesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonDynamicPropertiesFail({ error }));
  }
}

export function* watchGetDynamicProperties() {
  yield takeLatest(GET_AMLS_COMMON_DYNAMIC_PROPERTIES, function* ({ payload }) {
    yield fork(amlsGetDynamicProperties, payload);
  });
}

function* amlsPutDynamicPropertiesUpdate(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const { moduleId, ...data } = payload;
    const response = yield call(
      networkLayerObject.amlsCommonPutDynamicPropertiesUpdateAPI,
      moduleId,
      data
    );
    yield put(ga.fetchSuccess());

    if (response.data?.status === 'success') {
      yield put(putAMLSCommonDynamicPropertiesUpdateSuccess(response.data));
    } else {
      yield put(putAMLSCommonDynamicPropertiesUpdateFail(response.data));
    }
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(putAMLSCommonDynamicPropertiesUpdateFail({ error }));
  }
}

export function* watchPutDynamicPropertiesUpdate() {
  yield takeLatest(
    PUT_AMLS_COMMON_DYNAMIC_PROPERTIES_UPDATE,
    function* ({ payload, getDynamicPropertiesPayload }) {
      yield fork(
        amlsPutDynamicPropertiesUpdate,
        payload,
        getDynamicPropertiesPayload
      );
    }
  );
}

function* amlsGetPipelines(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetPipelinesAPI,
      payload
    );
    yield put(getAMLSCommonPipelinesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonPipelinesFail({ error }));
  }
}

export function* watchGetPipelines() {
  yield takeLatest(GET_AMLS_COMMON_PIPELINES, function* ({ payload }) {
    yield fork(amlsGetPipelines, payload);
  });
}

function* amlsPostPipelinesRun(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonPostPipelinesRunAPI,
      payload
    );
    if (response?.pipelineId) {
      yield put(
        getAMLSCommonPipelines({
          moduleId: payload.moduleId
        })
      ); // fetch Pipelines on success

      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: en.actions.runPipeline.successMessage
      });
    } else if (response.msg) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#FF0000' }} className="fa fa-warning"></i>
            &nbsp;&nbsp;Error
          </p>
        ),
        description: response.msg
      });
    }
    yield put(postAMLSCommonPipelinesRunSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(postAMLSCommonPipelinesRunFail({ error }));
  }
}

export function* watchPostPipelinesRun() {
  yield takeLatest(POST_AMLS_COMMON_PIPELINES_RUN, function* ({ payload }) {
    yield fork(amlsPostPipelinesRun, payload);
  });
}

function* amlsPostPipelinesSchedule(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonPostPipelinesScheduleAPI,
      payload
    );
    if (response?.id) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `Pipeline scheduled.`
      });
    }
    if (response.msg) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#FF0000' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Error
          </p>
        ),
        description: response.msg
      });
    }
    yield put(postAMLSCommonPipelinesScheduleSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(postAMLSCommonPipelinesScheduleFail({ error }));
  }
}

export function* watchPostPipelinesSchedule() {
  yield takeLatest(
    POST_AMLS_COMMON_PIPELINES_SCHEDULE,
    function* ({ payload }) {
      yield fork(amlsPostPipelinesSchedule, payload);
    }
  );
}

function* amlsPostPipelinesUnSchedule(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonPostPipelinesUnScheduleAPI,
      payload
    );
    if (response?.id) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `Pipeline successfully unscheduled.`
      });
    }
    if (response.msg) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#FF0000' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Error
          </p>
        ),
        description: response.msg
      });
    }
    yield put(postAMLSCommonPipelinesUnScheduleSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(postAMLSCommonPipelinesUnScheduleFail({ error }));
  }
}

export function* watchPostPipelinesUnSchedule() {
  yield takeLatest(
    POST_AMLS_COMMON_PIPELINES_UNSCHEDULE,
    function* ({ payload }) {
      yield fork(amlsPostPipelinesUnSchedule, payload);
    }
  );
}

function* amlsGetPipelinesScheduleInfo(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetPipelinesScheduleInfoAPI,
      payload
    );
    // if (response.msg) {
    //   notification.open({
    //     message: (
    //       <p>
    //         <i style={{ color: '#FF0000' }} className="fa fa-check"></i>
    //         &nbsp;&nbsp;Error asd
    //       </p>
    //     ),
    //     description: response.msg
    //   });
    // }
    yield put(getAMLSCommonPipelinesScheduleInfoSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonPipelinesScheduleInfoFail({ error }));
  }
}

export function* watchGetPipelinesScheduleInfo() {
  yield takeLatest(
    GET_AMLS_COMMON_PIPELINES_SCHEDULE_INFO,
    function* ({ payload }) {
      yield fork(amlsGetPipelinesScheduleInfo, payload);
    }
  );
}

function* amlsGetPipelinesHistory(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const { id, ...params } = payload;
    const response = yield call(
      networkLayerObject.amlsCommonGetPipelinesHistoryAPI,
      id,
      {
        is_new: true,
        ...params
      }
    );
    if (response.msg) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#FF0000' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Error
          </p>
        ),
        description: response.msg
      });
    }
    yield put(
      getAMLSCommonPipelinesHistorySuccess({
        ...response,
        pipelineId: payload.id
      })
    );
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonPipelinesHistoryFail({ error }));
  }
}

export function* watchGetPipelinesHistory() {
  yield takeLatest(GET_AMLS_COMMON_PIPELINES_HISTORY, function* ({ payload }) {
    yield fork(amlsGetPipelinesHistory, payload);
  });
}

function* amlsPostPipelineStop(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonPostPipelineStopAPI,
      payload
    );
    if (response?.id || response?.msg) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `${response?.msg}`
      });
    }
    yield put(postAMLSCommonPipelineStopSuccess(response));
    yield put(ga.fetchSuccess());
    yield put(getAMLSCommonPipelines(payload));
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(postAMLSCommonPipelineStopFail({ error }));
  }
}

export function* watchPostPipelineStop() {
  yield takeLatest(POST_AMLS_COMMON_PIPELINE_STOP, function* ({ payload }) {
    yield fork(amlsPostPipelineStop, payload);
  });
}

function* amlsGetCommonNotifications(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsCommonGetNotificationsAPI,
      payload
    );
    yield put(getAMLSCommonNotificationsSuccess(response));
    // yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSCommonNotificationsFail({ error }));
  }
}

export function* watchGetCommonNotifications() {
  yield takeLatest(GET_AMLS_COMMON_NOTIFICATIONS, function* ({ payload }) {
    yield fork(amlsGetCommonNotifications, payload);
  });
}

export function* fetchAmlsAlertLevelWorker() {
  try {
    const alertLevels = yield call(
      networkLayerObject.amlsCommonGetAlertLevelList
    );
    if (isArray(alertLevels))
      yield put(fetchAMLSAlertLevelSuccess(alertLevels));
    else yield put(fetchAMLSAlertLevelFail(alertLevels?.message));
  } catch (error) {
    yield put(fetchAMLSAlertLevelFail(error));
  }
}

export function* watchFetchAmlsAlertLevel() {
  yield takeEvery(FETCH_AMLS_ALERT_LEVEL, function* () {
    yield fork(fetchAmlsAlertLevelWorker);
  });
}
